var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { Component } from 'react';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import _, { last, defer } from 'lodash';
import MarkerTool from './MarkerTool';
import colors from '../utils/colors';
import constants from '../utils/constants';
import { MarkingType, isSpaceTag, isTableTag } from '../types/floorplan';
import { isSpaceEdited, isTableEdited } from '../utils/mark-utils';
import ImageOptions from './ImageOptions';
import { FloorImageContainer } from './FloorImageContainer';
import FloorImageContent from './FloorImageContent';
import { Header } from '../components/Header';
import { createUseGesture, pinchAction } from '@use-gesture/react';
var FloorPlanMarkContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: calc(100% - 24px);\n  padding-top: 24px;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  box-shadow: 0 6px 20px 4px ", ";\n"], ["\n  height: calc(100% - 24px);\n  padding-top: 24px;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n  box-shadow: 0 6px 20px 4px ", ";\n"])), colors.WHITE, colors.TP_GRAY);
var UpperContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  padding: 0 32px;\n  flex: 0 0 auto;\n"], ["\n  padding: 0 32px;\n  flex: 0 0 auto;\n"])));
var LowerContainer = styled(FloorImageContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  flex: 1 1 auto;\n"], ["\n  flex: 1 1 auto;\n"])));
var LowerContainerWithPinch = function (props) {
    var pinchRef = React.useRef(null);
    var useGesture = createUseGesture([pinchAction]);
    useGesture({
        onPinch: function (_a) {
            var offset = _a.offset[0], memo = _a.memo, event = _a.event;
            event.preventDefault();
            var previousState = memo || {
                offset: 0,
                direction: 1,
                changesCount: 0,
            };
            var newDirection = offset > previousState.offset ? 1 : -1;
            if (newDirection == previousState.direction) {
                if (previousState.changesCount > 2) {
                    props.changeZoomLevel(newDirection * 0.1);
                }
                previousState.changesCount++;
            }
            else {
                previousState.direction = newDirection;
                previousState.changesCount = 0;
            }
            previousState.offset = offset;
            return previousState;
        },
    }, {
        target: pinchRef,
        pinch: { scaleBounds: { min: 0.5, max: 2 }, rubberband: true, pointer: { touch: true } },
    });
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { ref: pinchRef },
            React.createElement(LowerContainer, null, props.children))));
};
var PlanDescription = styled.p(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.42px;\n  line-height: 18px;\n  margin-top: 16px;\n"], ["\n  color: ", ";\n  font-size: 12px;\n  font-weight: 500;\n  letter-spacing: 0.42px;\n  line-height: 18px;\n  margin-top: 16px;\n"])), colors.TEXT_DEFAULT);
var FloorPlanMark = /** @class */ (function (_super) {
    __extends(FloorPlanMark, _super);
    function FloorPlanMark(props) {
        var _this = _super.call(this, props) || this;
        _this.isInFlight = function () {
            return _this.state.inFlight > 0;
        };
        _this.inFlight = function (lambda) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ inFlight: this.state.inFlight + 1 });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, , 3, 4]);
                        return [4 /*yield*/, lambda()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        this.setState({ inFlight: this.state.inFlight - 1 });
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        _this.floorImg = React.createRef();
        // Change current floor plan.
        _this.updateFloor = function (selectedFloor) {
            _this.props.floorPlanStore.setCurrentFloor(selectedFloor);
        };
        _this.setZoomLevel = function (level) {
            _this.setState({ zoomLevel: level });
        };
        _this.changeZoomLevel = function (increment) {
            _this.setState({ zoomLevel: Math.max(_this.state.zoomLevel + increment, 0.1) });
        };
        // Call after editing or saving new space / table.
        _this.initializeState = function () {
            var spaceOptions = (_this.props.spacesStore &&
                _this.props.floorPlanStore.currentFloor &&
                _this.props.spacesStore.spaceOptionsOnAFloor(_this.props.floorPlanStore.currentFloor)) ||
                [];
            _this.setState({
                editTag: null,
                pctX: null,
                pctY: null,
                spaceNumber: '',
                tableLetter: '',
                openSpace: false,
                spaceOptions: spaceOptions,
                selectedOption: null,
            });
        };
        _this.onMarkerClick = function (event, tag) {
            if (_this.isInFlight()) {
                return;
            }
            _this.initializeState();
            if (isSpaceTag(tag)) {
                _this.openMarkerToolEdit(tag.title, undefined);
            }
            if (isTableTag(tag)) {
                _this.openMarkerToolEdit(tag.space, tag.letter);
            }
            event.stopPropagation();
        };
        _this.setSuggestions = function (markingTypeArg, selectedOptionArg) {
            var markingType = markingTypeArg || _this.state.markType;
            var suggestedOption = selectedOptionArg || _this.state.selectedOption || null;
            var currentFloor = _this.props.floorPlanStore.currentFloor;
            if (!_this.props.spacesStore || !currentFloor) {
                return;
            }
            if (markingType === MarkingType.Space) {
                _this.setState({
                    spaceNumber: _this.props.spacesStore.suggestSpaceNumber(currentFloor) + '',
                });
            }
            else if (markingType === MarkingType.Table && !suggestedOption) {
                var mostRecentSpace_1 = last(currentFloor.spaces);
                if (mostRecentSpace_1) {
                    suggestedOption = _this.state.spaceOptions.find(function (option) { return option.label === mostRecentSpace_1.title; }) || null;
                    _this.setState({
                        spaceNumber: mostRecentSpace_1.title,
                        tableLetter: _this.props.spacesStore.suggestTableLetter(mostRecentSpace_1.tables),
                        selectedOption: suggestedOption,
                    });
                }
            }
            else if (markingType === MarkingType.Table && suggestedOption) {
                var space = currentFloor.spaces.find(function (s) { return s.title === suggestedOption.label; });
                if (space) {
                    _this.setState({
                        spaceNumber: space.title,
                        tableLetter: _this.props.spacesStore.suggestTableLetter(space.tables),
                        selectedOption: suggestedOption,
                    });
                }
            }
        };
        // Opens the tool for creating a new marker in clicked position.
        _this.openMarkerTool = function (e) {
            if (!_this.props.spacesStore || !_this.props.floorPlanStore.currentFloor) {
                return;
            }
            if (_this.isInFlight()) {
                return;
            }
            _this.setState({
                editTag: null,
                pctX: (e.nativeEvent.offsetX / _this.floorImg.current.width) * 100,
                pctY: (e.nativeEvent.offsetY / _this.floorImg.current.height) * 100,
                openSpace: false,
                spaceOptions: _this.props.spacesStore.spaceOptionsOnAFloor(_this.props.floorPlanStore.currentFloor),
            });
            _this.setSuggestions();
        };
        _this.openMarkerToolEdit = function (space, table) {
            if (!_this.props.spacesStore || !_this.props.floorPlanStore.currentFloor) {
                return;
            }
            if (table) {
                var markers = _this.props.floorPlanStore.tableTags;
                var marker = markers.find(function (m) { return m.space === space && m.letter === table; });
                if (marker) {
                    var spaceOptions = _this.props.spacesStore.spaceOptionsOnAFloor(_this.props.floorPlanStore.currentFloor);
                    var selectedOption = spaceOptions.find(function (option) { return option.value === space; });
                    _this.setState({
                        editTag: marker,
                        pctX: marker.positionX,
                        pctY: marker.positionY,
                        spaceNumber: marker.space,
                        tableLetter: marker.letter,
                        openSpace: false,
                        markType: MarkingType.Table,
                        spaceOptions: _this.props.spacesStore.spaceOptionsOnAFloor(_this.props.floorPlanStore.currentFloor),
                        selectedOption: selectedOption || null,
                    });
                }
            }
            else {
                var markers = _.isNil(_this.props.floorPlanStore.currentFloor)
                    ? []
                    : _this.props.floorPlanStore.currentFloor.spaces;
                var index = markers.findIndex(function (e) { return e.title === space; });
                if (index > -1) {
                    _this.setState({
                        editTag: markers[index],
                        pctX: markers[index].positionX,
                        pctY: markers[index].positionY,
                        spaceNumber: markers[index].title,
                        openSpace: markers[index].openSpace,
                        tableLetter: '',
                        markType: MarkingType.Space,
                    });
                }
            }
        };
        _this.editSpaceTag = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inFlight(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.state.editTag && isSpaceTag(this.state.editTag))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.props.floorPlanStore.editSpace(this.state.editTag, this.state.spaceNumber, this.state.openSpace)];
                                    case 1:
                                        _a.sent();
                                        this.initializeState();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.editTableTag = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inFlight(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.state.editTag && isTableTag(this.state.editTag))) return [3 /*break*/, 2];
                                        return [4 /*yield*/, this.props.floorPlanStore.editTable(this.state.editTag, this.state.spaceNumber, this.state.tableLetter)];
                                    case 1:
                                        _a.sent();
                                        this.initializeState();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.saveSpaceTag = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inFlight(function () { return __awaiter(_this, void 0, void 0, function () {
                            var tag;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.state.pctX && this.state.pctY)) return [3 /*break*/, 2];
                                        tag = {
                                            title: this.state.spaceNumber,
                                            positionX: this.state.pctX,
                                            positionY: this.state.pctY,
                                            openSpace: this.state.openSpace,
                                            tables: [],
                                        };
                                        return [4 /*yield*/, this.props.floorPlanStore.addSpace(tag)];
                                    case 1:
                                        _a.sent();
                                        this.initializeState();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.saveTableTag = function () { return __awaiter(_this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.inFlight(function () { return __awaiter(_this, void 0, void 0, function () {
                            var tag;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(this.state.pctX && this.state.pctY)) return [3 /*break*/, 2];
                                        tag = {
                                            space: this.state.spaceNumber,
                                            letter: this.state.tableLetter,
                                            positionX: this.state.pctX,
                                            positionY: this.state.pctY,
                                        };
                                        return [4 /*yield*/, this.props.floorPlanStore.addTable(tag)];
                                    case 1:
                                        _a.sent();
                                        this.initializeState();
                                        _a.label = 2;
                                    case 2: return [2 /*return*/];
                                }
                            });
                        }); })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        // CONTROLLED COMPONENT FUNCTIONS
        _this.validateTag = function () {
            if (_this.state.markType === MarkingType.Space) {
                if (_this.state.editTag && isSpaceTag(_this.state.editTag)) {
                    if (isSpaceEdited(_this.state.editTag, _this.state.spaceNumber, _this.state.openSpace)) {
                        _this.editSpaceTag();
                    }
                    else {
                        // No changes to save.
                        _this.initializeState();
                    }
                }
                else {
                    var space = _.isNil(_this.props.floorPlanStore.currentFloor)
                        ? undefined
                        : _this.props.floorPlanStore.currentFloor.spaces.find(function (space) { return space.title === _this.state.spaceNumber; });
                    if (space === undefined) {
                        _this.saveSpaceTag();
                    }
                    else {
                        // TODO: Show information view of existing space.
                        _this.initializeState();
                    }
                }
            }
            else if (_this.state.markType === MarkingType.Table) {
                if (_this.state.editTag && isTableTag(_this.state.editTag)) {
                    if (isTableEdited(_this.state.editTag, _this.state.spaceNumber, _this.state.tableLetter)) {
                        _this.editTableTag();
                    }
                    else {
                        // No changes to save.
                        _this.initializeState();
                    }
                }
                else {
                    var table = _this.props.floorPlanStore.tableTags.find(function (table) { return table.space + table.letter === _this.state.spaceNumber + _this.state.tableLetter; });
                    if (table === undefined) {
                        _this.saveTableTag();
                    }
                    else {
                        // TODO: Show information view of existing table.
                        _this.initializeState();
                    }
                }
            }
        };
        _this.deleteTag = function () {
            if (_this.state.editTag && isSpaceTag(_this.state.editTag)) {
                // if (isSpaceAssigned(this.state.editTag)) {
                //   // TODO: Show dialog to remove tag with owner
                // }
                _this.props.floorPlanStore.removeSpace(_this.state.editTag);
            }
            else if (_this.state.editTag && isTableTag(_this.state.editTag)) {
                // if (isTableAssigned(this.state.editTag)) {
                //   // TODO: Show dialog to remove tag with owner
                // }
                _this.props.floorPlanStore.removeTable(_this.state.editTag);
            }
            _this.initializeState();
            console.log('Remove tag');
        };
        _this.changeSpaceNumber = function (name) {
            _this.setState({ spaceNumber: name });
        };
        _this.changeTableLetter = function (name) {
            // Forces the letter to consist of only alpha characters
            var longString = name.toUpperCase().replace(/[^A-ZÅÄÖÆØ]/g, '');
            _this.setState({
                tableLetter: longString.length > 0 ? longString.charAt(0) : '',
            });
        };
        _this.changeMarkingType = function (type) {
            _this.setState({ markType: type });
            _this.setSuggestions(type);
        };
        _this.changeOpenSpace = function () {
            _this.setState({ openSpace: !_this.state.openSpace });
        };
        _this.changeSelectedOption = function (value) {
            _this.setState({ selectedOption: value });
            _this.setSuggestions(undefined, value);
        };
        _this.state = {
            pctX: null,
            pctY: null,
            spaceNumber: '',
            tableLetter: '',
            openSpace: false,
            markType: MarkingType.Space,
            editTag: null,
            spaceOptions: [],
            selectedOption: null,
            zoomLevel: constants.ZOOM_LEVEL_DEFAULT,
            inFlight: 0,
        };
        _this.saveSpaceTag = _this.saveSpaceTag.bind(_this);
        _this.saveTableTag = _this.saveTableTag.bind(_this);
        _this.openMarkerTool = _this.openMarkerTool.bind(_this);
        _this.onMarkerClick = _this.onMarkerClick.bind(_this);
        _this.validateTag = _this.validateTag.bind(_this);
        _this.deleteTag = _this.deleteTag.bind(_this);
        _this.updateFloor = _this.updateFloor.bind(_this);
        _this.changeSpaceNumber = _this.changeSpaceNumber.bind(_this);
        _this.changeTableLetter = _this.changeTableLetter.bind(_this);
        _this.changeSelectedOption = _this.changeSelectedOption.bind(_this);
        _this.initializeState = _this.initializeState.bind(_this);
        _this.setZoomLevel = _this.setZoomLevel.bind(_this);
        _this.setSuggestions = _this.setSuggestions.bind(_this);
        _this.inFlight = _this.inFlight.bind(_this);
        _this.isInFlight = _this.isInFlight.bind(_this);
        _this.containerRef = React.createRef();
        return _this;
    }
    FloorPlanMark.prototype.componentDidMount = function () {
        defer(this.setDefaultScrollPosition.bind(this));
    };
    FloorPlanMark.prototype.setDefaultScrollPosition = function () {
        if (this.containerRef.current) {
            var el = this.containerRef.current.querySelector('.indiana-scroll-container');
            if (el) {
                el.scrollLeft = constants.MARKER_TOOL_WIDTH / 2;
                el.scrollTop = constants.MARKER_TOOL_WIDTH / 2;
            }
        }
    };
    FloorPlanMark.prototype.render = function () {
        var _a = this.props.floorPlanStore, currentFloor = _a.currentFloor, tableTags = _a.tableTags;
        var _b = this.state, pctX = _b.pctX, pctY = _b.pctY, spaceNumber = _b.spaceNumber, tableLetter = _b.tableLetter, openSpace = _b.openSpace, markType = _b.markType, spaceOptions = _b.spaceOptions, selectedOption = _b.selectedOption, zoomLevel = _b.zoomLevel;
        // A bit dumb check for null, but TS \o/
        if (_.isNil(currentFloor)) {
            return;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Header, null, "Add spaces and tables"),
            React.createElement(FloorPlanMarkContainer, { ref: this.containerRef },
                React.createElement(UpperContainer, null,
                    React.createElement(PlanDescription, null, "Choose and click a spot the floor plan to mark a space or table there. "),
                    React.createElement(ImageOptions, { onZoom: this.setZoomLevel, zoomLevel: this.state.zoomLevel })),
                React.createElement(LowerContainerWithPinch, { changeZoomLevel: this.changeZoomLevel },
                    React.createElement(FloorImageContent, { forwardedRef: this.floorImg, currentFloor: currentFloor, zoomLevel: zoomLevel, initialFit: "contain", imageMargin: constants.MARKER_TOOL_WIDTH / 2, tableTags: tableTags, onImageClick: this.openMarkerTool, onMarkerClick: this.onMarkerClick }, pctX && pctY && (React.createElement(MarkerTool, { x: pctX, y: pctY, spaceNumber: spaceNumber, tableLetter: tableLetter, options: spaceOptions, selectedOption: selectedOption, openSpace: openSpace, markingType: markType, onOK: this.validateTag, onDelete: this.deleteTag, onClose: this.initializeState, onSpaceNumberChange: this.changeSpaceNumber, onTableLetterChange: this.changeTableLetter, onMarkingTypeChange: this.changeMarkingType, onOpenSpaceChange: this.changeOpenSpace, onOptionSelected: this.changeSelectedOption })))))));
    };
    FloorPlanMark = __decorate([
        inject('floorPlanStore'),
        inject('spacesStore'),
        observer
    ], FloorPlanMark);
    return FloorPlanMark;
}(Component));
export default FloorPlanMark;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=FloorPlanMark.js.map